

















import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import uploader from '@/components/commonForm/uploader.vue'
import uploadList from '@/views/sheet/components/uploadList.vue'
import widgetCommon from './widgetCommon'
import {uuid} from '@/utils/common'
import {clone} from 'lodash'
@Component({
  components: {
    uploader,
    uploadList
  }
})
export default class extends Mixins(widgetCommon) {
  private progress: any = null
  public get value () {
    let v = this.form[this.item.businessId] || []
    return v.length ? '1' : ''
  }
  private get list () {
    let list = clone(this.form[this.item.businessId] || [])
    if (this.item.arrangeType === 2) {
      list.reverse()
    }
    return list
  }
  public created () {
    // 解决表单保存附件没有校验必填的问题
    if (this.form[this.item.businessId] === null) {
      this.form[this.item.businessId] = [];
    }
  }
  // 解决表单保存附件没有校验必填的问题
  // private clickHandler () {
  //   this.showUploader = true;
  //   this.$nextTick(() => {
  //     const child: any = this.$refs.uploader;
  //     child.$refs.uploader.chooseFile();
  //   })
  //   this.form[this.item.businessId] = [];
  // }
  private keyFun (type) {
    let companyId = this.$store.state.user.user.companyId
    return `${companyId}/discussion/${this.$route.params.worksheetId}/${uuid()}.` + type
  }
  private remove (index) {
    if (this.disabled) {
      return
    }
    let indexTrue = index
    if (this.item.arrangeType === 2) {
      indexTrue = this.list.length - 1 - index
    }
    this.form[this.item.businessId].splice(indexTrue, 1)
  }
  private progressFn (data) {
    this.progress = data
  }
  private uploadSuccess (file) {
    this.form[this.item.businessId] = this.form[this.item.businessId] || []
    // 最近上传的在前
    this.progress = null
    this.form[this.item.businessId].unshift(file)
  }
}
